/**
 * Константы навигации
 */
export const NAV_ITEMS = [
    { label: "ПРО НАС", href: "#about" },
    { label: "КОМПЛЕКТИ", href: "#kits" },
    { label: "ВІДГУКИ", href: "#reviews" },
    { label: "КОНТАКТИ", href: "#contacts" },
];

export const SECTION_IDS = {
    ABOUT: "about",
    KITS: "kits",
    REVIEWS: "reviews",
    CONTACTS: "contacts",
};

